import apiClient from './apiClient'
import type { ContactTag } from '../types/conversation.types'

export type { ContactTag }

const DEFAULT_TAG_COLOR = '#6B7280'

export const tagService = {
  async listTags(): Promise<{ success: boolean; data: ContactTag[] }> {
    const response = await apiClient.get('/tags')
    return response.data
  },

  async createTag(name: string, color: string = DEFAULT_TAG_COLOR): Promise<{ success: boolean; data?: ContactTag; message?: string }> {
    const response = await apiClient.post('/tags', { name, color })
    return response.data
  },

  async updateTag(
    id: number,
    name: string,
    color: string
  ): Promise<{ success: boolean; data?: ContactTag; message?: string }> {
    const response = await apiClient.put(`/tags/${id}`, { name, color })
    return response.data
  },

  async deleteTag(id: number): Promise<{ success: boolean; message?: string }> {
    const response = await apiClient.delete(`/tags/${id}`)
    return response.data
  },

  async syncConversationTags(
    conversationId: number,
    tagIds: number[]
  ): Promise<{ success: boolean; message?: string }> {
    const response = await apiClient.put(`/tags/conversations/${conversationId}`, { tag_ids: tagIds })
    return response.data
  },

  async syncClientTags(clientId: number, tagIds: number[]): Promise<{ success: boolean; message?: string }> {
    const response = await apiClient.put(`/tags/clients/${clientId}`, { tag_ids: tagIds })
    return response.data
  }
}

export const DEFAULT_CONTACT_TAG_COLOR = DEFAULT_TAG_COLOR
